import { render, staticRenderFns } from "./LibraryReadingInstanceEditor.vue?vue&type=template&id=526c093d&"
import script from "./LibraryReadingInstanceEditor.vue?vue&type=script&lang=ts&"
export * from "./LibraryReadingInstanceEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports